import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams, ToastController } from 'ionic-angular';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Globals } from "../../../../globals";
import { MenuServices } from "../../services";
import { StaticsServices } from '../../../services/statics';
import { getCurrencySymbol } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { MenuCreateExtrasPage } from '../menu-create-extras/menu-create-extras';
import { AddonsTriggerVersionProPage } from '../../../addons/addons-trigger-version-pro/addons-trigger-version-pro';
import { CartaMenuViewPage } from '../../../cartas-menus/carta-menu-view/carta-menu-view';
import { AnalyticsServices } from '../../../services/analyticsServices';

/**
 * Generated class for the MenuCreatePricenextrasPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-menu-create-pricenextras',
    templateUrl: 'menu-create-pricenextras.html',
})
export class MenuCreatePricenextrasPage {
    public form: FormGroup;
    menu_uid: string;
    menu_name: string;
    update_state: boolean = false;
    _currency: any = '€';
    type: string = '';
    new_menu: boolean = false;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public loadingCtrl: LoadingController,
        public fb: FormBuilder,
        private toastCtrl: ToastController,
        public globals: Globals,
        public menuServices: MenuServices,
        public staticsServices: StaticsServices,
        public translate: TranslateService,
        public analyticsServices: AnalyticsServices) {

        this.update_state = this.navParams.get('update');
        this.menu_uid = this.navParams.get('menu_uid');
        this.menu_name = this.navParams.get('menu_name');
        this.type = this.navParams.get('type');
        this.new_menu = this.navParams.get('new_menu');
        this._currency = getCurrencySymbol(this.globals.user_currency, 'narrow', 'es');

        this.form = fb.group({
            price: [this.navParams.get('price'), Validators.compose([Validators.required])],
            price_takeaway: [this.navParams.get('price_takeaway')],
            pan_vino_agua_si: [this.navParams.get('pan_vino_agua_si')],
            pan_vino_agua_no: [this.navParams.get('pan_vino_agua_no')],
            refresco_si: [this.navParams.get('refresco_si')],
            refresco_no: [this.navParams.get('refresco_no')],
            cafe_si: [this.navParams.get('cafe_si')],
            cafe_no: [this.navParams.get('cafe_no')],
            extra_price: [this.navParams.get('extra_price')],
            footer: [this.navParams.get('footer')],
        });
        //Si se esta creando el menu, vaciamos el array
        if (!this.update_state) {
            this.menuServices.sections_extra_array_tmp = [];
        }
    }


    submit() {
        if (this.form.valid) {
            //Update
            this.update();
        } else {
            let toast = this.toastCtrl.create({
                message: this.translate.instant('instant-introduce-precio-menu-continuar'),
                duration: 3000,
                position: 'bottom'
            });
            toast.present();
        }
    }

    update() {
        //Create object extras footer
        var _obj = {
            pan_vino_agua_si: this.form.value.pan_vino_agua_si,
            pan_vino_agua_no: this.form.value.pan_vino_agua_no,
            refresco_si: this.form.value.refresco_si,
            refresco_no: this.form.value.refresco_no,
            cafe_si: this.form.value.cafe_si,
            cafe_no: this.form.value.cafe_no,
        };

        this.menuServices.afs.collection('menus').doc(this.menu_uid).update({
            'price': this.form.value.price,
            'price_takeaway': this.form.value.price_takeaway,
            'footer': this.form.value.footer,
            'extra': this.form.value.extra_price,
            'extras_footer': _obj,
            'updated_at': new Date(),
        }).then(() => {

            //calculate menu cost
            this.staticsServices.updateMenuCost(this.menu_uid);

            this.menuServices.menu_cost = 0;
            this.menuServices.sumands = 0;
            this.menuServices.count_tmp = 0;

            if (this.new_menu == true) {
                this.analyticsServices.trackingExp('finisher', this.globals.tracking_exp['finisher'], '');
                //save plg_cartamenu_finisher true
                this.menuServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
                    plg_cartamenu_finisher: true
                });
                this.globals.restaurant.plg_cartamenu_finisher = true;
            }

            if (this.update_state) {
                this.globals.GAtrackView('Menu', 'Menu - Price extras - Update', this.globals.restaurant.email, 'Create/Update', 'Update price extras', 'Menu', '');
                this.navCtrl.pop();
            } else {
                this.globals.GAtrackView('Menu', 'Menu - Price extras - Create', this.globals.restaurant.email, 'Create/Update', 'Create price extras', 'Menu', '');
                //
                this.globals.tourLaunchStep(18);
                //
                this.navCtrl.setRoot(CartaMenuViewPage, {
                    type: 'menu',
                    state: 'new',
                    uid_element: this.menu_uid
                });
            }
        });
    }

    addExtras() {
        if (this.globals.checkLimitsByLicense('daily_menu', 'suplements')) {
            this.navCtrl.push(MenuCreateExtrasPage, {
                update: this.update_state,
                menu_uid: this.menu_uid,
                menu_name: this.menu_name,
            });
        } else {
            this.navCtrl.push(AddonsTriggerVersionProPage);
        }
    }


}


// WEBPACK FOOTER //
// ./src/pages/menu/menu-create/menu-create-pricenextras/menu-create-pricenextras.ts